import globalConfiguration from '@/api/config/globalConfiguration'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useGlobalById(interfaceId: any, id: any) {
  return useQuery([[queryKeys.globalConfiguration], id], async () => {
    if (!interfaceId || !id) return null
    const { data } = await globalConfiguration.getById(
      interfaceId.toString(),
      id.toString(),
    )
    if (!data) return null

    return data
  })
}

export default useGlobalById
